export default {
    'OPERACION_ENVIADO': (state, mutation) => {
        state.finalizado = mutation.finalizado
    }
}